import { observer } from "mobx-react-lite";
import useDefaultMapLayer from "../../hooks/useDefaultMapLayer";
import ILayerProps from "../../interfaces/IlayerProps";

function RailsMapLayer({ visible }: ILayerProps) {
    useDefaultMapLayer(visible, () => [
        "Railways",
        "Metro",
    ]);

    return (
        <></>
    );
}

export default observer(RailsMapLayer);